import { render } from "./NotificationsTable.vue?vue&type=template&id=1be2a192"
import script from "./NotificationsTable.vue?vue&type=script&lang=js"
export * from "./NotificationsTable.vue?vue&type=script&lang=js"

import "./NotificationsTable.vue?vue&type=style&index=0&id=1be2a192&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__